/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FeedbackComponentDisplay } from "cms/components/components/feedback/display";
import { FeedbackComponentEditor } from "cms/components/components/feedback/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

const FeedbackComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <FeedbackComponentDisplay />,
        editComponent: <FeedbackComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

FeedbackComponent.displayName = "FeedbackComponent";
export { FeedbackComponent };
